import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Pis.css';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import WeekSlider from '../common/WeekSlider';
import * as actions from '../Actions';

const service = new Service();

class Pis extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        let currentweek = 0;
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['result']) {
            initialData = serverSideData['result'];
            currentweek = initialData.currentWeek;
        }
        this.state = {
            initialData: initialData,
            currentweek: parseInt(currentweek),
            clickwedWeek: parseInt(currentweek),
            pisStyle: this.getTestStyleObj(initialData),
            WeekSliderData: this.getWeekSliderData(initialData),
            scrollwidth: 0,
            halfwidth: 0,
            weekwd: 0,
            weeks: [],
            trimester_txt: 'First Trimester',
            IsExpected: false,
            isApp: false,
            metaTitle: "Pregnancy Checkup Schedule – Tests, Screening, Scans & more",
            metaDescription: [
                { "name": "description", "content": "Prenatal medical care is most important to monitor the health of pregnant woman and baby. Find more about checkups to be done during pregnancy for a healthy baby & You. Get more information about antenatal care at FirstCry Parenting." },
                { "name": "keywords", "content": "prenatal care, pregnancy checkup, medical examination during pregnancy" },
                { "name": "atdlayout", "content": "tools_sp" }
            ]
        };
        this.timeout = 0;
        this.weeksOnSide = 0;
        this.testClassObj = {
            "upcoming": "bar-upcome",
            "overdue": "bar-overdue",
            "done": "bar-done",
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "preginspection/getpregnancyinspectiontest";
        let body = JSON.stringify({});
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        this.callOnScroll = this.callOnScroll.bind(this);
        if (this.props.location.search.includes('from=app')) {
            this.setState({ isApp: true });
        }
        document.querySelector('.preg-scroll').addEventListener("scroll", this.callOnScroll, false);
        console.log(this.state.initialData);
        document.getElementsByClassName('pregnancy-reports')[0].style.width = document.getElementsByClassName('preg-scroll')[0].offsetWidth + 'px';
        // debugger;
        let trimesterbottom = document.querySelector(".preg-scroll").offsetHeight - document.querySelector(".pregn-reports-cnt").offsetHeight - 40 - 10;
        document.querySelector(".trimester-txt").style.bottom = trimesterbottom + "px";
        
        if (this.state.currentweek > 1) {
            this.setState({ IsExpected: true });
        } else {
            this.setState({ IsExpected: false });
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.pisData();
            } else {
                localStorage.setItem('pisDataLanding', JSON.stringify(this.state.initialData));
                this.setViewStates();
            }
        } else {
            if (localStorage.getItem('pisDataLanding')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('pisDataLanding')),
                    pisStyle: this.getTestStyleObj(JSON.parse(localStorage.getItem('pisDataLanding'))),
                    WeekSliderData: this.getWeekSliderData(JSON.parse(localStorage.getItem('pisDataLanding'))),
                    currentweek: parseInt(JSON.parse(localStorage.getItem('pisDataLanding')['currentWeek'])),
                    clickwedWeek: parseInt(JSON.parse(localStorage.getItem('pisDataLanding')['currentWeek']))
                }, () => { this.setViewStates(); });
            }
            service.hideLoader();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.callOnScroll, false);
    }

    getWeekSliderData(initialData) {
        let WeekSliderData = [];
        let totalWeek = (initialData && initialData.totalWeek) ? parseInt(initialData.totalWeek) : 40;
        for (let i = 0; i < totalWeek; i++) {
            WeekSliderData.push({ week: (i + 1) });
        }
        return WeekSliderData;
    }

    setViewStates() {
        this.setState({
            scrollwidth: document.querySelector('.preg-scroll').offsetWidth,
            halfwidth: document.querySelector('.preg-scroll').offsetWidth / 2,
            weekwd: document.querySelector('.week-bar li').offsetWidth,
            weeks: document.querySelectorAll('.week-bar li')
        }, () => { this.setScrollView(); });
    }

    setScrollView() {
        let a;
        let scrolllft = 0;
        for (let j = 1; j <= document.querySelectorAll('.week-bar li').length; j++) {
            let wd = j * this.state.weekwd;
            if (wd > this.state.halfwidth) {
                a = j - 1;
                this.weeksOnSide = a;
                break
            }
        }
        for (let i = 0; i <= document.querySelectorAll('.week-bar li').length; i++) {
            if (this.state.weeks[i].classList.contains('sel-week')) {
                scrolllft = (this.state.weekwd * (i - a));
                document.querySelector('.preg-scroll').scrollLeft = scrolllft;
                document.getElementsByClassName('pregnancy-reports')[0].style.width = (document.getElementsByClassName('preg-scroll')[0].offsetWidth + scrolllft)
                this.setTrimesterText(this.state.clickwedWeek);
                break
            }
        }
    }

    callOnScroll() {
        let leftPos = document.querySelector('.preg-scroll').scrollLeft;
        if (document.getElementsByClassName('pregnancy-reports')[0].offsetWidth <= document.querySelector('.weeks-section').offsetWidth) {
            document.getElementsByClassName('pregnancy-reports')[0].style.width = (document.getElementsByClassName('preg-scroll')[0].offsetWidth + leftPos) + 'px';
        }
        var scroll_width = document.querySelector('.preg-scroll').offsetWidth;
        if (leftPos !== 0 && (scroll_width + leftPos) < document.querySelector('.week-bar').offsetWidth) {
            let weekno = Math.floor((leftPos) / this.state.weekwd) + this.weeksOnSide + 1;
            this.setState({ clickwedWeek: weekno });
            this.setTrimesterText(weekno);
        }
    }

    setTrimesterText(weekno) {
        this.setState({ trimester_txt: actions.getPragnancyTrimesterText(weekno) });
    }

    pisData() {
        var postData = {}
        var url = global.api_ci_url + "Pis/getPisLandingData";
        service.postServiceCall(url, postData).then((json) => {
            console.log(json);
            if (json['result']) {
                this.setState({
                    initialData: json['result'],
                    pisStyle: this.getTestStyleObj(json['result']),
                    WeekSliderData: this.getWeekSliderData(json['result']),
                    currentweek: parseInt(json['result']['currentWeek']),
                    clickwedWeek: parseInt(json['result']['currentWeek'])
                }, () => { this.setViewStates(); });
                localStorage.setItem('pisDataLanding', JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    getTestStyleObj(data) {
        let testAry = [];
        if (data.test) {
            testAry = data.test;
        }
        let styleObj = {};
        for (let i = 0; i < testAry.length; i++) {
            let test = testAry[i];
            let topObj = {
                "6testid631": "0",
                "6testid601": "0",
                "6testid611": "0",
                "6testid661": "0",
                "6testid671": "0",
                "6testid641": "0",
                "6testid651": "55px",
                "6testid6a1": "55px",
                "6testid6b1": "55px",
                "6testid632b1": "55px",
                "6testid632a1": "55px",
                "6testid63291": "111px",
                "6testid63281": "111px",
                "6testid632f1": "111px",
                "6testid632e1": "111px",
                "6testid632d1": "167px",
                "6testid632c1": "167px",
                "6testid63231": "167px",
                "6testid63221": "223px",
                "6testid602b1": "223px",
                "6testid602a1": "280px",
                "6testid60291": "280px",
                "6testid60281": "336px",
                "6testid602f1": "336px",
                "6testid602e1": "336px",
                "6testid602d1": "393px",
                "6testid602c1": "450px",
                "6testid60231": "506px",
                "6testid60221": "563px",
                "6testid612b1": "620px"
            }
            let weekwd = (this.state && this.state.weekwd && this.state.weekwd > 0) ? this.state.weekwd : 85;
            let obj = {
                width: ((test.endWeek - test.startWeek + 1) * weekwd) + "px",
                left: ((test.startWeek - 1) * weekwd) + "px",
                top: topObj[test.id]
            }
            styleObj[test.id] = obj;
        }
        return styleObj;
    }

    manageReport(id, title) {
        if (global.ftk != '') {
            if (this.state.IsExpected) {
                let newTitle = title.trim().replace(/\s/g, "_").replace(/\//g, "+");
                this.props.history.push(service.getRedirectUrl("/tools/pregnancy-checkup-schedule/manageReports/" + newTitle + '/' + id));
            } else {
                document.querySelector('.define-duedate').style.display = 'block';
            }
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    addDuedate() {
        this.closeDuedatePopup();
        window.location.href = '/my-account/?URL=' + global.currentURL;
    }

    closeDuedatePopup() {
        document.querySelector('.define-duedate').style.display = 'none';
    }

    render() {
        return (
            <main className="main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Pregnancy Inspection Schedule</span>
                    </div>
                    <div className="preg-inp">
                        <h1 className="B24_00">Pregnancy Inspection Schedule</h1>
                        <Link to={service.getRedirectUrl("/tools/pregnancy-checkup-schedule/how-it-work")} className="right">
                            <span className="icon i-icon" data-icon-font=""></span>
                        </Link>
                    </div>
                </div>
                {this.state.isApp &&
                    <div className="preg-inp preg-inp-app">
                        <h1 className="B24_00">Pregnancy Inspection Schedule</h1>
                        <Link to={service.getRedirectUrl("/tools/pregnancy-checkup-schedule/how-it-work")} className="right">
                            <span className="icon i-icon" data-icon-font=""></span>
                        </Link>
                    </div>
                }
                <div className="sub-container left">
                    <div className="pis-landing data-container left">
                        <div className="pregnancy-inspt">
                            <div className="pregnancy-top">
                                <div className="inspection">
                                    <div className="pregnancy sub_1">
                                        <div className="pregnancy-inner sub_inner_1">
                                            <p>{(this.state.initialData && this.state.initialData.overdueCount) ? this.state.initialData.overdueCount : '0'}</p>
                                        </div>
                                    </div>
                                    <p className="preg-txt left">Overdue</p>
                                </div>
                                <div className="inspection upcoming">
                                    <div className="pregnancy sub_2">
                                        <div className="pregnancy-inner sub_inner_2">
                                            <p>{(this.state.initialData && this.state.initialData.upcomingCount) ? this.state.initialData.upcomingCount : '0'}</p>
                                        </div>
                                    </div>
                                    <p className="preg-txt left">Upcoming</p>
                                </div>
                                <div className="inspection">
                                    <div className="pregnancy sub_3">
                                        <div className="pregnancy-inner sub_inner_3">
                                            <p>{(this.state.initialData && this.state.initialData.doneCount) ? this.state.initialData.doneCount : '0'}</p>
                                        </div>
                                    </div>
                                    <p className="preg-txt left">Done</p>
                                </div>
                            </div>
                            <div className="preg-scroll">
                                <div className="pregn-reports-cnt">
                                    <div className="pregnancy-reports">
                                        <ul className="preg-tests">
                                            {this.state.initialData && this.state.initialData.test && this.state.initialData.test.length > 0 && this.state.initialData.test.map((test, index) =>
                                                <li key={index} id={test.id} className={`tests ${this.testClassObj[test.status]}`} style={this.state.pisStyle[test.id]} onClick={() => this.manageReport(test.id, test.title)}>
                                                    <span className="dev_testTitle">{test.title}</span>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                    <WeekSlider eleRef={this} WeekBdata={this.state.WeekSliderData} weekKey={'week'} keyVal={1} tool={'pis'} />
                                    <div className="trimester-cnt">
                                        <div className="trimester fst-trimester" style={{ width: (this.state.weekwd * 12) + "px" }}>
                                            <span></span>
                                        </div>
                                        <div className="trimester sec-trimester" style={{ width: (this.state.weekwd * 14) + "px" }}>
                                            <span></span>
                                        </div>
                                        <div className="trimester trd-trimester" style={{ width: ((this.state.weekwd * 14) + 40) + "px" }}>
                                            <span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="trimester-txt">{this.state.trimester_txt}</div>
                        </div>
                    </div>
                </div>
                <div className="define-duedate">
                    <div className="duedate-msg">
                        <div className="R15_42">For using this tool due date need to be defined in system</div>
                        <div className="sel-opt M15_75">
                            <span className="yesno" id="no" onClick={()=>this.closeDuedatePopup()}>No</span>
                            <span className="yesno M15_fc88af" id="yes" onClick={()=>this.addDuedate()}>Yes</span>
                        </div>
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )
    }
}

export default Pis;



// WEBPACK FOOTER //
// src/shared/tools/pis/Pis.js